import { gql } from '@apollo/client';

export const GET_INTEGRATIONS_STATUS = gql`
  query GetIntegrationsStatus($storeId: ID!) {
    getIntegrationsStatus(storeId: $storeId) {
      __typename
      ... on GetIntegrationsStatusSuccess {
        code
        status {
          cliqueRetire
          vtex
          correios
          memphis
        }
      }
      ... on Error {
        message
        code
      }
    }
  }
`;
